import { cn } from '@/platform/lib/utils';
import { Button, Header } from '@/platform/ui';
import { PencilIcon } from '@heroicons/react/24/outline';
import { usePage } from '@inertiajs/react';

const SelectedCustomer = () => {
    const { auth } = usePage().props;

    return (
        <div className='mb-8 flex flex-col justify-between border-b border-gray-300 pb-4 sm:flex-row'>
            <div className='flex items-center justify-center gap-4 sm:justify-start'>
                <div
                    className={cn(
                        'size-5 rounded-full',
                        auth.customer.status == 1 && 'bg-red-500',
                        auth.customer.status == 0 && 'bg-orange-500',
                        auth.customer.status == 2 && 'bg-green-500'
                    )}
                />
                <Header as='h2' className='text-primary-500'>
                    {auth.customer.number}
                </Header>
                <div>
                    <Header subheader={auth.customer.reseller?.name} as='h3'>
                        {auth.customer.name}
                    </Header>
                </div>
            </div>
            <div className='mt-4 flex items-center justify-between gap-4'>
                {auth.customer?.managers?.length > 0 && (
                    <div className='sm:border-r sm:border-gray-300 sm:pr-4 sm:text-right'>
                        <p className='text-xs text-gray-500 uppercase'>
                            Relatiebeheerder:
                        </p>
                        <p className='text-xs'>
                            {auth.customer?.managers
                                ?.map(manager => manager.name)
                                ?.join(' | ')}
                        </p>
                    </div>
                )}
                <Button
                    // TODO: Change to Link
                    as='a'
                    href={`/customers/${auth.customer.id}/edit`}
                >
                    <PencilIcon className='size-4' />
                </Button>
            </div>
        </div>
    );
};

export default SelectedCustomer;
